/**
 * One-time migration: attach legacy rows (no planner_event) to the user's first planner event.
 */

import { getApiUrl } from '@/lib/api'

export async function migrateUnassignedPlannerLinks(
  token: string,
  userId: number,
  targetPlannerEventId: number
): Promise<void> {
  const API_URL = getApiUrl()
  const headers: HeadersInit = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  }

  const patchIfNeeded = async (
    collection: string,
    items: Array<{ id: number; documentId?: string }>
  ) => {
    for (const item of items) {
      const rid = item.documentId ?? item.id
      await fetch(`${API_URL}/api/${collection}/${rid}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
          data: { planner_event: targetPlannerEventId },
        }),
      })
    }
  }

  /**
   * Only rows Strapi reports with planner_event truly null (legacy never linked).
   * Do NOT use a "fetch all and guess" fallback: after a planner-event is deleted,
   * broken relations can look like null in the API and would be wrongly reassigned
   * to the user's first remaining event.
   */
  const fetchOrphans = async (
    collection: string
  ): Promise<Array<{ id: number; documentId?: string }>> => {
    const q = `filters[user][id]=${userId}&filters[planner_event][$null]=true&pagination[pageSize]=200`
    const res = await fetch(`${API_URL}/api/${collection}?${q}`, { headers })
    if (!res.ok) {
      console.warn(
        `[migrate] skip ${collection}: planner_event[$null] query failed (${res.status})`
      )
      return []
    }
    const j = await res.json()
    const rows = j.data || []
    return rows.map((row: any) => ({
      id: row.id,
      documentId: row.documentId,
    }))
  }

  const gl = await fetchOrphans('guest-lists')
  await patchIfNeeded('guest-lists', gl)

  const budgets = await fetchOrphans('budgets')
  await patchIfNeeded('budgets', budgets)

  const todos = await fetchOrphans('todos')
  await patchIfNeeded('todos', todos)
}
